class MailTemplateId {
  constructor(private readonly _value: number = NaN) {
  }

  public equals(other: MailTemplateId): boolean {
    return this._value === other.value;
  }

  public isEmpty(): boolean {
    return isNaN(this._value);
  }

  get value() {
    return this._value;
  }
}

export default MailTemplateId;
